<template>
  <div id="order">
    <div class="adaptive-column-content">
      <h2 class="main">{{ isSmartphone ? 'Корзина' : 'Оформление заказа' }}</h2>
      <content-loader title="Пожалуйста, подождите, мы загружаем Ваш заказ" v-if="!menuLoaded" />
      <template v-else>
        <narrow-cart :promotionsGifts="form.promotionsGifts" v-if="isSmartphone" />
        <template v-else>
          <div class="desktop-items">
            <div class="cart-item" v-for="(line, index) in cartLinesWithData" :key="index">
              <div class="image" :style="{'background-image': `url('${image(line.dish.image)}')`}" :class="{ 'use-contain': line.dish.image_use_contain }"></div>
              <div class="info">
                <div class="title">{{ line.dish.post_title }}, <span class="size">{{ line.dish.size }}</span></div>
                <div class="desc">{{ line.dish.desc }}</div>
              </div>
              <quantity-selector
                :amount="line.quantity"
                @clickMinus="removeFromCart(line.id)"
                @clickPlus="addToCart(line.id)"
              />
              <div class="price-cont">
                <div class="price">{{ (+line.dish.price - +line.dish.discount) * line.quantity | money }} <rub /></div>
                <div class="crossed-price" v-if="line.dish.discount">{{ +line.dish.price * line.quantity | money }} <rub /></div>
              </div>
              <div class="remove-button" @click="removeLineFromCart(line.id)"><svg-inline :src="require('@/assets/icons/remove.svg')" /></div>
            </div>
            <div class="cart-item" v-for="(dish, promotionId) in form.promotionsGifts" :key="promotionId">
              <div class="image" :style="{'background-image': `url('${image(dish.image)}')`}" :class="{ 'use-contain': dish.image_use_contain }"></div>
              <div class="info">
                <div class="title">{{ dish.post_title }}, <span class="size">{{ dish.size }}</span></div>
                <div class="desc">{{ dish.desc }}</div>
              </div>
              <div class="quantity-selector-mock"></div>
              <div class="price-cont">
                <div class="gift-icon"><svg-inline :src="require('@/assets/icons/gift.svg')" /></div>
                <div class="crossed-price">{{ +dish.price | money }} <rub /></div>
              </div>
              <div class="remove-button-mock"></div>
            </div>
          </div>
          <div class="desktop-items-delivery-line">
            <template v-if="totalSum >= 1400">
              <div class="label">Доставка:</div>
              <div class="price">бесплатно</div>
            </template>
            <template v-else-if="totalSum >= 1200">
              <div class="label">Доставка:</div>
              <div class="price">бесплатно для <router-link :to="{ name: 'Conditions' }">зон 1 и 2</router-link></div>
            </template>
            <template v-else-if="totalSum >= 800">
              <div class="label">Доставка:</div>
              <div class="price">бесплатно для <router-link :to="{ name: 'Conditions' }">зоны 1</router-link></div>
            </template>
            <template v-else>
              <div class="message">Минимальная сумма заказа составляет 800 <rub />, пожалуйста, добавьте что-то ещё.</div>
            </template>
          </div>
          <div class="desktop-items-total-line">
            <div class="label">Сумма заказа:</div>
            <div class="crossed-price" v-if="cartHasDiscount">{{ totalSumBeforeDiscount | money }} <rub /></div>
            <div class="price">{{ totalSum | money }} <rub /></div>
          </div>
        </template>

        <template v-if="availableGiftsByPromotions.length > 0">
          <h2 class="gifts">Заберите {{ availableGiftsByPromotions.length > 1 ? 'подарки' : 'подарок' }}!</h2>
          <div class="gift-promotion" v-for="giftPromotionData in availableGiftsByPromotions">
            <div class="options">
              <template v-if="!isSmartphone">
                <div class="option" :class="{ 'inactive': dish.needSum }" v-for="(dish, index) in giftPromotionData.dishes">
                  <dish
                    :dish="dish"
                    :giftMode="true"
                    :giftSelected="form.promotionsGifts[giftPromotionData.id] && form.promotionsGifts[giftPromotionData.id].ID === dish.ID"
                    @selectGift="$set(form.promotionsGifts, giftPromotionData.id, dish)"
                  />
                  <div class="min-sum-mark" v-if="dish.needSum">Нужно заказать на {{ dish.needSum }} <rub /></div>
                </div>
              </template>
              <gift-dishes-swiper
                :promotionsGifts="form.promotionsGifts"
                :giftPromotionData="giftPromotionData"
                @selectGift="dish => { $set(form.promotionsGifts, giftPromotionData.id, dish) }"
                v-else
              />
            </div>
          </div>
        </template>

        <h2 class="form">Доставка и оплата</h2>
        <form id="order-form">
          <div class="delivery-fields">
            <div class="row phone">
              <input-container type="tel" label="Телефон" inputId="phone" :required="true" v-model="form.phone" @input="onPhoneInput" :class="{ 'has-error': $v.form.phone.$error }" />
              <input-container type="number" label="Приборы" inputId="people" :required="true" v-model="form.people" :class="{ 'has-error': $v.form.people.$error }" />
            </div>
            <input-container label="Имя" inputId="name" :required="true" v-model="form.name" :class="{ 'has-error': $v.form.name.$error }" />
            <div class="row address">
              <input-container label="Улица, дом" inputId="street-house" v-model="form.streetHouse" :required="true" :class="{ 'has-error': $v.form.streetHouse.$error }" />
              <input-container label="Квартира" inputId="flat" v-model="form.flat" />
            </div>
            <input-container type="textarea" v-model="form.comment" label="Комментарий к доставке" inputId="comment" />
          </div>
          <div class="hor-line"></div>
          <div class="payment-fields">
            <input-container type="select" label="Способ оплаты" inputId="payment-method" v-model="form.paymentMethod" :selectOptions="paymentMethods" />
            <input-container type="number" label="Сдача с" inputId="cashChange" :required="true" v-model="form.cashChange" v-if="form.paymentMethod.code === 'cash' && !noCashChange" />
            <input-container type="checkbox" label="Без сдачи" inputId="noCashChange" v-model="noCashChange" v-if="form.paymentMethod.code === 'cash'" />
          </div>
          <div class="final-row" v-if="!isSmartphone">
            <div class="label">К оплате</div>
            <div class="crossed-price" v-if="cartHasDiscount">{{ totalSumBeforeDiscount | money }} <rub /></div>
            <div class="price">{{ totalSum | money }} <rub /></div>
            <mangal-button
              class="red"
              :class="{ 'disabled': totalSum < 800 }"
              :loading="isLoading"
              @click.native="processSubmit"
              text="Оформить заказ"
            />
          </div>
          <template v-else>
            <div class="total-line">
              <div class="label">Сумма заказа:</div>
              <div class="crossed-price" v-if="cartHasDiscount">{{ totalSumBeforeDiscount | money }} <rub /></div>
              <div class="price">{{ totalSum | money }} <rub /></div>
            </div>
            <mangal-button
              class="red"
              :class="{ 'disabled': totalSum < 800 }"
              :loading="isLoading"
              @click.native="processSubmit"
              text="Оформить заказ"
            />
          </template>
          <div class="error-message" v-if="createOrderFailed">Извините, произошла ошибка при попытке создать заказ. Мы уже занимаемся решением данной проблемы. Пожалуйста, позвоните нам по номеру <phone />, чтобы мы могли помочь Вам оформить заказ!</div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Phone from '/src/components/Phone'
  import QuantitySelector from '/src/components/QuantitySelector'
  import ContentLoader from '/src/components/ContentLoader'
  import InputContainer from '/src/components/InputContainer'
  import MangalButton from '/src/components/MangalButton'
  import NarrowCart from '/src/components/NarrowCart'
  import Dish from '/src/components/Dish'
  import GiftDishesSwiper from '/src/components/GiftDishesSwiper'

  import { forEach, map, filter } from 'lodash'

  import { required } from 'vuelidate/lib/validators'
  import Velocity from 'velocity-animate'
  // const INDEX_OF_NINE = 4

  export default {
    name: 'OrderPage',
    components: {
      GiftDishesSwiper,
      NarrowCart,
      QuantitySelector,
      ContentLoader,
      InputContainer,
      MangalButton,
      Phone,
      Dish
    },
    data () {
      let paymentMethods = [
        {
          code: 'card-offline',
          label: 'Картой курьеру'
        },
        {
          code: 'cash',
          label: 'Наличными курьеру'
        }
      ]

      return {
        isLoading: false,
        form: {
          phone: '+7 (',
          people: 1,
          name: '',
          streetHouse: '',
          flat: '',
          comment: '',
          paymentMethod: paymentMethods[0],
          cashChange: 2000,
          promotionsGifts: {}
        },
        noCashChange: false,
        paymentMethods: paymentMethods,
        createOrderFailed: false
      }
    },
    validations () {
      return {
        form: {
          phone: {
            required,
            notEmpty: input => !(input === '+7 ('),
            // hasNine: input => ((input.length >= 4 && +input[INDEX_OF_NINE] === 9) || input.length <= 4),
            format: input => input.length > 4 ? /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(input) : true
          },
          people: {
            required
          },
          name: {
            required
          },
          streetHouse: {
            required
          }
        }
      }
    },
    methods: {
      ...mapActions({
        addToCart: 'cart/addToCart',
        removeFromCart: 'cart/removeFromCart',
        removeLineFromCart: 'cart/removeLineFromCart',
        createOrder: 'cart/createOrder',
        clearCart: 'cart/clearCart'
      }),
      image (lineImage) {
        return lineImage || require('@/assets/images/nophoto.jpg')
      },
      onPhoneInput (value) {
        if (value !== '+7 (' && value) {
          this.form.phone = value
        } else {
          this.form.phone = value
          // this.$v.phone.$reset()
        }
      },
      processSubmit () {
        if (this.$v.form.$invalid) {
          this.$v.form.$touch()
          Velocity(document.getElementById('order-form'), 'scroll', {
            duration: 300,
            offset: -document.getElementById('site-header').offsetHeight - 10
          })
        } else {
          this.createOrderFailed = false
          this.isLoading = true

          if (this.noCashChange) {
            this.form.cashChange = this.totalSum
          }
          this.createOrder(this.form).then((body) => {
            // let orderId = body.orderId
            this.clearCart()
            this.$router.push({ name: 'SuccessPage', params: { type: 'order' } })
          }).catch((e) => {
            console.log('e', e)
            this.createOrderFailed = true
          }).finally(() => {
            this.isLoading = false
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        totalSum: 'cart/totalSum',
        totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
        totalItems: 'cart/totalItems',
        cartLinesWithData: 'cart/cartLinesWithData',
        menuLoaded: 'menu/menuLoaded',
        availableGiftsByPromotions: 'cart/availableGiftsByPromotions'
      }),
      cartHasDiscount () {
        return this.totalSumBeforeDiscount !== this.totalSum
      }
    },
    watch: {
      totalSum (newVal, oldVal) {
        forEach(this.availableGiftsByPromotions, (giftPromotionData) => {
          let giftIds = map(filter(giftPromotionData.dishes, dish => !dish.needSum), dish => dish.ID)
          if (this.form.promotionsGifts[giftPromotionData.id]) {
            if (!(giftIds.includes(this.form.promotionsGifts[giftPromotionData.id].ID))) {
              this.$delete(this.form.promotionsGifts, giftPromotionData.id)
            }
          }
        })
      }
    },
    mounted () {
      if (this.totalItems === 0) {
        this.$router.push({ name: 'Index' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/Order.vue